export default "/_next/static/assets/MuseoSansCondensed-500_f3f5b416473e309e2bddc2f9c172d488.woff2";